export default {"src":"/_next/static/media/qrcode-frame.977cc73d.svg","height":260,"width":257};